import React from "react";
import { Link } from "gatsby";

const SideBarTitleItem = props => {
    return (
        <div className="author-box recent-donate-item">
            <div className="author__avatar" style={{backgroundColor:"#fff0"}}>
                <img src={props.blogContent.ImagePath} width="60" height="60" alt="" />
            </div>
            <div className="author__detail">
                <h4 className="author__title author__title2">
                    <Link to={props.blogContent.TitleLink}>{props.blogContent.Title}</Link>
                </h4>
                <ul className="author__list">
                    <li>{props.blogContent.Description}</li>
                </ul>
                {/* <span className="author__meta2">$20</span> */}
                <strong>
                    <span className="author__meta2">
                        <i className="fa fa-inr"></i> {props.blogContent.Amount}
                    </span>
                </strong>
            </div>
        </div>
    );
};

export default SideBarTitleItem;
